import useSWR from 'swr';
import AxiosConfig from '../../../config/AxiosConfig';

const fetcher = async (url) =>
  await AxiosConfig.create('get', url).call().getResponseData();

function useStores(userID) {
  const { data, error, mutate } = useSWR(
    userID ? `/stores/` : null,
    (url) => fetcher(url),
    {
      refreshInterval: import.meta.env.VITE_API_POLLING_INTERVAL,
      revalidateOnFocus: true,
    }
  );

  return {
    stores: data,
    error,
    mutate: mutate,
  };
}

export default useStores;
